<template>
  <div class="text-center">
    <v-dialog
      v-model="showModal"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 mb-2"
          primary-title
        >
          Agenda
        </v-card-title>

        <v-card-text>
          <template>
            <v-card class="mt-1">
              <v-card-title>Perfil</v-card-title>
              <v-card-text>
                <div>Nome: <strong>{{ instrutorConfig.instrutor.nome }} </strong></div>
                <div>CPF: <strong>{{ instrutorConfig.instrutor.cpf }} </strong></div>
              </v-card-text>
              <v-card-text>
                <p>Categorias Habilitadas</p>
                <v-chip-group
                  column
                >
                  <v-chip
                    v-for="(cat, index) in instrutorConfig.config.categorias_ativo"
                    :key="index"
                    class="deep-purple accent-4 white--text"
                  >
                    {{ cat }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>

              <v-divider class="mx-4" />

              <v-card-title>Horários</v-card-title>

              <v-card-text>
                <p>Dias</p>
                <v-chip-group
                  column
                >
                  <v-chip
                    v-for="(day, index) in instrutorConfig.config.dias_ativo"
                    :key="index"
                    class="deep-purple accent-4 white--text"
                  >
                    {{ day }}
                  </v-chip>
                </v-chip-group>
                <p>Horários</p>
                <v-chip class="deep-purple accent-4 white--text">
                  {{ instrutorConfig.config.hora_inicio }} as {{ instrutorConfig.config.hora_fim }}
                </v-chip>
              </v-card-text>
              <v-divider class="mx-4" />
              <v-card-title>Veículo</v-card-title>
              <v-card-text>
                <div> Apelido: <strong>{{ instrutorConfig.config.veiculo.apelido }} </strong></div>
                <div> Placa: <strong>{{ instrutorConfig.config.veiculo.placa }} </strong></div>
                <div>Categoria: <strong>{{ instrutorConfig.config.veiculo.categoria }} </strong></div>
              </v-card-text>
              <v-divider class="mx-4" />
            </v-card>
          </template>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  export default {
    props: {
    showModal: {
      type: Boolean,
    },
    instrutorConfig:{
      type: Object
    }
  },
  data () {
    return {}
  },
  }
</script>
